import React from 'react';
import './AdvantagesDetail.css';

// Data for each of the advantage sections
const advantagesContent = [
  {
    id: 'confident-negotiations',
    title: 'Confident Negotiations',
    text: 'Approach every discussion with data-backed confidence. CRISHI’s transparent pricing benchmarks and real-time market intelligence equip you with the facts you need to negotiate strategically. Whether you’re buying, selling, or renegotiating contracts, you’ll walk into the room with data you can trust and the confidence to back up your position.'
  },
  {
    id: 'connect-learn-grow',
    title: 'Connect, Learn & Grow',
    text: 'Beyond data, CRISHI is a platform for connection. Attending our conferences, plant tours, expert-led webinars and podcasts to stay engaged with market leaders, policy voices, and operational experts. These experiences help you stay informed, inspire new ideas, strengthen networks, and help you stay ahead of industry change.'
  },
  {
    id: 'audits-compliance',
    title: 'Audits & Compliance',
    text: 'Streamline compliance and reduce audit risk with structured, timestamped data records. CRISHI’s assessments and historical data serve as reliable documentation for internal reviews, regulatory filings, and tax audits helping you demonstrate transparency, consistency, and control.'
  },
  {
    id: 'data-analysis-archive',
    title: 'Trade data analysis & data archive',
    text: 'Use the past to shape the future. Our data archive lets you explore historical price trends, trade volumes, and key shifts in market behavior. Whether you’re forecasting, budgeting, or conducting risk analysis, CRISHI provides the context and clarity to support long-term strategic decisions.'
  }
];

const AdvantagesDetail = () => {
  return (
    <section className="advantages-detail-section">
      <div className="advantages-detail-container">
        {/* Left Column: Sticky Navigation */}
        <aside className="advantages-nav">
          <ul>
            {advantagesContent.map(item => (
              <li key={item.id}>
                <a href={`#${item.id}`}>{item.title}</a>
              </li>
            ))}
          </ul>
        </aside>

        {/* Right Column: Main Content */}
        <main className="advantages-content">
          {advantagesContent.map(item => (
            <div key={item.id} id={item.id} className="content-section">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </main>
      </div>
    </section>
  );
};

export default AdvantagesDetail;